export const ultimasNoticias = [
    {
        "imagen" : "https://taquilla.cecultah.gob.mx/wp-content/uploads/2024/04/WhatsApp-Image-2024-05-01-at-2.25.26-PM-1536x623.jpeg",
        "url" : "https://taquilla.cecultah.gob.mx/events/concierto-star-wars-2024/",
        "titulo" : "Concierto Star Wars 2024",
        "fecha" : "Jueves 27 de junio del 2024, 19:00 horas"
    },
    {
        "imagen" : "https://cpcef.net/CONCURSO/img/tema.png",
        "url" : "https://s-contraloria.hidalgo.gob.mx/descargables/Convocatoria%20Transparencia%20en%20Corto%202024%20Modificado.pdf",
        "titulo" : "Convocatoria del Premio Nacional de Transparencia en Corto 2024",
        "fecha" : "Julio del 2024"
    },


    /* {
        "imagen" : "../assets/imgs/fiestam4.jpg",
        "url" : "https://taquilla.cecultah.gob.mx/events/concierto-fiesta-mexicana-con-la-oseh-2023/",
        "titulo" : "Fiesta Mexicana",
        "fecha" : "miercoles 20 de septiembre del 2023, 18:00 horas"
    },
    {
        "imagen" : "../assets/imgs/fiestam3.jpg",
        "url" : "https://taquilla.cecultah.gob.mx/events/concierto-fiesta-mexicana-con-la-oseh-2023/",
        "titulo" : "Fiesta Mexicana",
        "fecha" : "miercoles 20 de septiembre del 2023, 18:00 horas"
    },
    {
        "imagen" : "../assets/imgs/fiestam2.jpg",
        "url" : "https://taquilla.cecultah.gob.mx/events/concierto-fiesta-mexicana-con-la-oseh-2023/",
        "titulo" : "Fiesta Mexicana",
        "fecha" : "miercoles 20 de septiembre del 2023, 18:00 horas"
    },
    {
        "imagen" : "../assets/imgs/fiestam1.jpg",
        "url" : "https://taquilla.cecultah.gob.mx/events/concierto-fiesta-mexicana-con-la-oseh-2023/",
        "titulo" : "Fiesta Mexicana",
        "fecha" : "miercoles 20 de septiembre del 2023, 18:00 horas"
    },
    {
        "imagen" : "../assets/imgs/movilidadArtistica.jpg",
        "titulo" : "Apoyo a Instituciones Estatales de Cultura AIEC 2023",
        
    },*/
]